export interface ContactInfo {
  name: string;
  email: string;
  phone: string;
  message?: string;
}

const CONTACT_STORAGE_KEY = 'collins_booking_contact';

// The guest's contact details are remembered in the browser between waitlist sign-ups
export function loadStoredContact(): ContactInfo | null {
  try {
    const stored = localStorage.getItem(CONTACT_STORAGE_KEY);
    if (stored) {
      const parsed = JSON.parse(stored);
      if (parsed.name || parsed.email || parsed.phone) {
        return {
          name: parsed.name || '',
          email: parsed.email || '',
          phone: parsed.phone || '',
          message: parsed.message || ''
        };
      }
    }
  } catch (e) {
    // Ignore parse errors
  }
  return null;
}

export function storeContact(contact: ContactInfo) {
  try {
    localStorage.setItem(CONTACT_STORAGE_KEY, JSON.stringify({
      name: contact.name,
      email: contact.email,
      phone: contact.phone,
      message: contact.message || ''
    }));
  } catch (e) {
    // Ignore storage errors
  }
}
